<template>
    <div v-if="model">
        <rkm-area
            no-margin-top
            title="Filtros"
            type="fieldset"
        >
            <rkm-form
                ref="Form"
                show-legend
            >
                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-multiselect
                            :options="form.papeis"
                            :select-limit="null"
                            @update:dropdownClosed="handlePapelClosed"
                            label="Papéis"
                            option-name-key="nome"
                            option-text-selecteds="papel selecionado"
                            v-model="model.papeis"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-form-multiselect
                            :options="form.modulos"
                            :select-limit="null"
                            @update:dropdownClosed="handleModuloClosed"
                            label="Módulos"
                            option-name-key="nome"
                            option-text-selecteds="módulo selecionado"
                            v-model="model.modulos"
                            value-field="id"
                        />
                    </rkm-col>
                </rkm-row>

                <rkm-row>
                    <rkm-col cols="6">
                        <rkm-form-multiselect
                            :options="form.funcionalidades"
                            :select-limit="null"
                            @update:dropdownClosed="handleFuncionalidadeClosed"
                            label="Funcionalidades"
                            option-name-key="nome"
                            option-text-selecteds="funcionalidade selecionada"
                            v-model="model.funcionalidades"
                            value-field="id"
                        />
                    </rkm-col>

                    <rkm-col cols="6">
                        <rkm-button
                            :label="false"
                            @click="$refs.Form.validate(search)"
                            color="primary"
                        >
                            Buscar
                        </rkm-button>

                        <rkm-button
                            :label="false"
                            @click="reset"
                        >
                            Limpar
                        </rkm-button>
                    </rkm-col>
                </rkm-row>
            </rkm-form>
        </rkm-area>

        <template v-if="data">
            <rkm-area
                no-margin-top
                title="Resultado"
            >
                <template v-slot:trailing>
                    <rkm-button
                        @click="print"
                        color="info"
                        small
                        title="Imprimir"
                    >
                        <rkm-icon icon="print" />
                    </rkm-button>

                    <rkm-button
                        @click="exportTo"
                        color="info"
                        small
                        title="Exportar"
                    >
                        <rkm-icon icon="file-export" />
                    </rkm-button>
                </template>

                <rkm-table
                    :fields="fields"
                    :items="data.itens"
                    :sort-by="sortBy"
                    :sort-desc="sortDesc"
                    @sort-changed="onSortChanged"
                />
            </rkm-area>
        </template>
    </div>
</template>

<script>
// Mixins.
import {error, file, repository, stringCase} from '@/mixins'

// Others.
import moment from 'moment'

// Vuex.
import {mapActions} from 'vuex'

export default {
    created() {
        this.repositories = {
            exportacao: this.getConectaSusRepository('exportacao.administracao'),
            impressao: this.getConectaSusRepository('impressao.administracao'),
            relatorioPermissaoPapel: this.getConectaSusRepository('administracao.relatorioPermissaoPapel'),
        }

        this.load()
    },
    data() {
        return {
            data: null,
            form: null,
            fields: [
                {key: 'papelNome', label: 'Papel', sortable: true},
                {key: 'moduloNome', label: 'Módulo', sortable: true},
                {key: 'funcionalidadeNome', label: 'Funcionalidade', sortable: true},
            ],
            model: null,
            others: {moment},
            sortBy: 'papelNome',
            sortDesc: false,
        }
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            this.setLoading()

            this.repositories.relatorioPermissaoPapel.create()
                .then((response) => {
                    this.form = response.data.form
                    this.model = response.data.model
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        search() {
            const request = {
                papeis: this.model.papeis,
                modulos: this.model.modulos,
                funcionalidades: this.model.funcionalidades,
            }

            this.setLoading()

            this.repositories.relatorioPermissaoPapel.index(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => this.data = Object.assign(response.data))
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        reset() {
            this.data = null

            this.load()

            this.$nextTick().then(() => this.$refs.Form.resetValidator())
        },
        print() {
            this.setLoading()

            const request = {
                papeis: this.model.papeis,
                modulos: this.model.modulos,
                funcionalidades: this.model.funcionalidades,
                sortBy: this.sortBy ? this.camelToSnake(this.sortBy) : null,
                sortDesc: this.sortDesc,
            }

            this.repositories.impressao.relatorioPermissaoPapel(this.camelObjectKeysToSnakeRecursive(request))
                .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                .finally(() => this.unsetLoading())
        },
        exportTo() {
            this.setLoading()

            const request = {
                papeis: this.model.papeis,
                modulos: this.model.modulos,
                funcionalidades: this.model.funcionalidades,
                sortBy: this.sortBy ? this.camelToSnake(this.sortBy) : null,
                sortDesc: this.sortDesc,
            }

            this.repositories.exportacao.relatorioPermissaoPapel(this.camelObjectKeysToSnakeRecursive(request))
                .then(({ data, headers }) => this.openFile(data, headers['content-type']))
                .finally(() => this.unsetLoading())
        },
        handlePapelClosed() {
            this.data = null

            const request = {
                listar: 'modulos',
                papeis: this.model.papeis,
            }

            this.setLoading()

            this.repositories.relatorioPermissaoPapel.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.form.modulos = response.data.modulos
                    this.form.funcionalidades = response.data.funcionalidades
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleModuloClosed() {
            this.data = null

            const request = {
                listar: 'funcionalidades',
                papeis: this.model.papeis,
                modulos: this.model.modulos,
            }

            this.setLoading()

            this.repositories.relatorioPermissaoPapel.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => this.form.funcionalidades = response.data.funcionalidades)
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        handleFuncionalidadeClosed() {
            this.data = null
        },
        onSortChanged(context) {
            this.sortBy = context.sortBy
            this.sortDesc = context.sortDesc
        },
    },
    mixins: [error, file, repository, stringCase],
}
</script>